export const OS_MODES = ['mac', 'win', 'lin'];

export const normalizeOsMode = (value) => (
  OS_MODES.includes(value) ? value : 'mac'
);

const DESKTOP_LAYOUTS = {
  mac: {
    shellPosition: 'top',
    shellSize: 30,
    shortcutsPlacement: 'dock',
    shortcutsOrientation: 'horizontal',
    safeArea: {
      top: 42,
      right: 12,
      bottom: 118,
      left: 12
    }
  },
  win: {
    shellPosition: 'bottom',
    shellSize: 44,
    shortcutsPlacement: 'desktop',
    shortcutsOrientation: 'grid',
    safeArea: {
      top: 20,
      right: 18,
      bottom: 66,
      left: 18
    }
  },
  lin: {
    shellPosition: 'left',
    shellSize: 78,
    shortcutsPlacement: 'desktop',
    shortcutsOrientation: 'column',
    safeArea: {
      top: 18,
      right: 18,
      bottom: 18,
      left: 96
    }
  }
};

export const resolveDesktopLayout = (mode) => {
  const osMode = normalizeOsMode(mode);
  return DESKTOP_LAYOUTS[osMode];
};

export const WINDOW_MANAGEMENT_IDS = ['profile', 'resume', 'projects'];
